document.addEventListener( 'DOMContentLoaded', () => {
	initializeSliders();
} );

function initializeSliders() {
	const sliders = document.querySelectorAll( '.k8-slider-basic' );

	sliders.forEach( ( slider ) => {
		const track = slider.querySelector( '.k8-slider-basic__track' );
		const viewport = slider.querySelector( '.k8-slider-basic__viewport' );
		const dotsContainer = slider.querySelector( '.k8-slider-basic__dots' );
		const prevBtn = slider.querySelector( '.k8-slider-basic__arrow--prev' );
		const nextBtn = slider.querySelector( '.k8-slider-basic__arrow--next' );

		if ( !track || !viewport ) return;

		const slides = Array.from( track.children );
		const slideCount = slides.length;

		slider.setAttribute( 'data-slides', slideCount );

		if ( slideCount <= 1 ) return;

		// =============================================
		// Clones: [lastClone, 0, 1, ..., n-1, firstClone]
		// =============================================
		const firstClone = slides[ 0 ].cloneNode( true );
		const lastClone = slides[ slideCount - 1 ].cloneNode( true );

		track.insertBefore( lastClone, slides[ 0 ] );
		track.appendChild( firstClone );

		let currentIndex = 1;      // first REAL slide
		let isTransitioning = false;

		const setTransform = () => {
			track.style.transform = `translateX(-${ currentIndex * 100 }%)`;
		};

		// Snap without animation, guaranteed by forced reflow.
		const snapTo = ( index ) => {
			track.style.transition = 'none';
			currentIndex = index;
			setTransform();
			void track.offsetHeight; // force reflow — commits the jump BEFORE re-enabling transition
			track.style.transition = '';  // fall back to the CSS rule
		};

		const getRealIndex = () => {
			return ( currentIndex - 1 + slideCount ) % slideCount;
		};

		const updateDots = () => {
			dotsContainer.querySelectorAll( '.k8-slider-basic__dot' ).forEach( ( dot ) => {
				const dotIndex = parseInt( dot.getAttribute( 'data-slide-index' ), 10 );
				dot.classList.toggle( 'is-active', dotIndex === getRealIndex() );
			} );
		};

		// =============================================
		// Initial position — no animation on load
		// =============================================
		snapTo( 1 );

		// =============================================
		// Dots
		// =============================================
		for ( let i = 0; i < slideCount; i++ ) {
			const dot = document.createElement( 'button' );
			dot.type = 'button';
			dot.className = 'k8-slider-basic__dot';
			dot.setAttribute( 'aria-label', `Go to slide ${ i + 1 }` );
			dot.setAttribute( 'data-slide-index', i );

			if ( i === 0 ) dot.classList.add( 'is-active' );

			dot.addEventListener( 'click', () => {
				const targetIndex = i + 1;
				if ( currentIndex === targetIndex ) return;  // already on this slide, skip
				if ( isTransitioning ) return;
				isTransitioning = true;
				currentIndex = targetIndex;
				setTransform();
				updateDots();
				resetAutoAdvance();
			} );

			dotsContainer.appendChild( dot );
		}

		// =============================================
		// Snap back when a clone finishes animating in
		// =============================================
		track.addEventListener( 'transitionend', ( e ) => {
			// Only react to the track's own transform transition,
			// not bubbled transitions from children.
			if ( e.target !== track || e.propertyName !== 'transform' ) return;

			if ( currentIndex === slideCount + 1 ) {
				snapTo( 1 );               // was showing firstClone → jump to real first
			} else if ( currentIndex === 0 ) {
				snapTo( slideCount );      // was showing lastClone → jump to real last
			}

			isTransitioning = false;
		} );

		// =============================================
		// Navigation
		// =============================================
		const advance = ( direction ) => {
			if ( isTransitioning ) return;
			isTransitioning = true;
			currentIndex += direction;
			setTransform();
			updateDots();
		};

		if ( prevBtn ) {
			prevBtn.addEventListener( 'click', () => {
				advance( -1 );
				resetAutoAdvance();
			} );
		}

		if ( nextBtn ) {
			nextBtn.addEventListener( 'click', () => {
				advance( 1 );
				resetAutoAdvance();
			} );
		}


		// =============================================
		// Swipe for mobile
		// =============================================
		let touchStartX = 0;

		track.addEventListener( 'touchstart', ( e ) => {
			touchStartX = e.touches[ 0 ].clientX;
		} );

		track.addEventListener( 'touchend', ( e ) => {
			const touchEndX = e.changedTouches[ 0 ].clientX;
			const diff = touchStartX - touchEndX;
			const threshold = 50;

			if ( Math.abs( diff ) < threshold ) return;

			if ( diff > 0 ) {
				advance( 1 );
			} else {
				advance( -1 );
			}

			resetAutoAdvance();
		} );

		// =============================================
		// Auto-advance every 3.5s
		// =============================================
		let autoAdvanceTimer;

		const startAutoAdvance = () => {
			autoAdvanceTimer = setInterval( () => {
				advance( 1 );   // auto-advance does NOT reset the timer
			}, 3500 );
		};

		const resetAutoAdvance = () => {
			clearInterval( autoAdvanceTimer );
			startAutoAdvance();
		};

		startAutoAdvance();
	} );
}